"use strict";

exports.__esModule = true;
exports["default"] = LogoQ;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function LogoQ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.427 13.489C29.427 6.074 23.415.063 16 .063 8.584.063 2.574 6.074 2.574 13.489S8.585 26.916 16 26.916c.788 0 1.538-.073 2.289-.203l-.023 5.225h3.776v-6.502c4.361-2.219 7.385-6.721 7.385-11.947zm-7.385 6.265v-4.323l-3.776 1.078.004 5.358a8.635 8.635 0 0 1-2.27.318 8.697 8.697 0 1 1 0-17.393 8.697 8.697 0 0 1 8.697 8.696 8.695 8.695 0 0 1-2.655 6.266z"
  }));
}